export * from './sidebar.directive';



// WEBPACK FOOTER //
// /var/www/portaldev/bullseye/src/app/directives/sidebar/index.ts